module.exports = __webpack_public_path__ + "img/edit.d68143c7.svg";